import {Link, Flex, TextProps, useMultiStyleConfig, LinkProps} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import React, {useCallback} from 'react'
import {Helmet} from 'react-helmet'
import {useAccessibilityState} from '_context'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'
interface AccessibilityBannerProps {
    isAtTop: boolean
}

/**
 * @name AccessibilityBanner
 *
 * @component
 *
 * @description
 * Renders the accessibility banner if AccessibilityProvider return the url to usablenet integration
 * The banner is inserted as first element of the header and must be before the SkipNavLink
 * Verify isServer status from app utils to add a script with helmet only during SSR, otherwise it will be downloaded 2 times
 * preventing the usability script working properly
 *
 * @param isAtTop
 *
 * @returns {React.FC<AccessibilityBannerProps>} Rendered Flex component and add a script to the header.
 */
const AccessibilityBanner: React.FC<AccessibilityBannerProps> = ({isAtTop}) => {
    const styles = useMultiStyleConfig('AccessibilityBanner', {isAtTop}) as Record<string, TextProps & LinkProps>
    const {isAccessibilityBannerEnabled, accessibilityScriptPath} = useAccessibilityState()

    const handleClick = useCallback(() => {
        const tryEnable = () => {
            if (typeof window.enableUsableNetAssistive === 'function') {
                window.enableUsableNetAssistive()
            } else {
                console.warn('Accessibility plugin is still loading')
                setTimeout(tryEnable, 500)
            }
        }

        tryEnable()
    }, [])

    return isAccessibilityBannerEnabled ? (
        <>
            {isServer && (
                <Helmet>
                    <script id="usntA42start" data-rapid="true" src={`${accessibilityScriptPath}`} type="text/javascript" async />
                </Helmet>
            )}
            <Flex {...styles.wrapper}>
                <Link {...styles.link} className="UsableNetAssistive" href="#" onClick={handleClick} data-testid="usnt-enable-link">
                    <FormattedMessage id="accessibility.link.enableusableNet" defaultMessage="Enable UsableNet Assistive" />
                </Link>
            </Flex>
        </>
    ) : (
        <></>
    )
}

export default React.memo(AccessibilityBanner)
